const locale = {
    placeholder: 'Chọn thời gian',
    rangePlaceholder: ['Bắt đầu', 'Kết thúc'],
};
export default locale;
